/**
 * .tuMetrics {"tu1": 0.94, "tu2": 0.95, "tu3": 2, "notes": "Single gate for which feed_events belong in my inbox", "tuVersion": "2.5"}
 * .help "Decides whether a feed event is for the signed-in user — recipients yes, senders of their own mentions/DMs no."
 */
import type { FeedEvent } from '../../types';

/**
 * Company-wide SELECT + realtime can deliver rows addressed to other people.
 * Only keep events that are for this user (or broadcasts they did not send).
 */
export function isFeedEventForUser(
  event: {
    type: FeedEvent['type'];
    userId?: string | null;
    initiatorId?: string | null;
    cardId?: string | null;
  },
  userId: string,
): boolean {
  if (!userId) return false;

  const isAnnouncementEvent = event.type === 'announcement_made';
  const isDirectlyForMe = event.userId === userId;
  const isBroadcast = event.userId === null || event.userId === undefined;
  const isInitiatedByMe = event.initiatorId === userId;
  const isRelevantCardEvent =
    event.cardId !== null && event.cardId !== undefined && event.userId === userId;

  // Announcements: one row per audience member, including when userId matches.
  if (isAnnouncementEvent && isDirectlyForMe) return true;

  return isDirectlyForMe || (isBroadcast && !isInitiatedByMe) || isRelevantCardEvent;
}
